<div class="backDrop center white" *ngIf="visible$ | async">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="{productSettings: productSettings$ | async, loading: loading$ | async} as context">
            <div class="modal-header">
                <h4 class="modal-title text-center">Product settings</h4>
            </div>
            <div class="modal-body">
                <dx-data-grid *ngIf="context.productSettings" style="margin: 0px" height="100%" width="100%" [dataSource]="context.productSettings">
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
	                <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>
                    <dxo-pager [showPageSizeSelector]="false"></dxo-pager>
                    <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
                    <dxo-selection mode="none"></dxo-selection>
                    <dxo-scrolling mode="standard" showScrollbar="always"></dxo-scrolling>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <dxo-export [enabled]="false"></dxo-export>

                    <dxi-column dataField="productCode" caption="Product Code" dataType="string" width="20%"></dxi-column>
                    <dxi-column dataField="productName" caption="Product Name" dataType="string" width="40%"></dxi-column>

                    <dxi-column dataField="handlingMode" [caption]="tl.productHandlingMode" [showEditorAlways]="true" editCellTemplate="handlingModeTemplate" width="180px" headerCellTemplate="handlingModeHeaderTemplate"></dxi-column>

                    <div *dxTemplate="let cellInfo of 'handlingModeTemplate'">
                        <dx-lookup [dataSource]="handlingModeOptions" valueExpr="id" displayExpr="description" [value]="cellInfo.value"
                            [usePopover]="false" (onValueChanged)="cellInfo.setValue($event.value)">
                            <dxo-drop-down-options width="30vw" height="60vh"></dxo-drop-down-options>
                        </dx-lookup>
                    </div>

                    <div *dxTemplate="let cellInfo of 'handlingModeHeaderTemplate'">
                        {{tl.productHandlingMode}}
                        <tooltip-circle *ngIf="tl.handlingModeTooltip" tooltipId="handlingmodeheadertooltip{{cellInfo.rowIndex}}"><div class="basic-tooltip-text">
                            <div [innerHtml]="tl.handlingModeTooltip"></div>
                            <table class="tooltip-table">
                                @for(option of handlingModeOptions; track option) {
                                    @if(option.tooltip) {
                                        <tr>
                                            <td><b>{{option.description}}:</b></td><td class="pl-2">{{option.tooltip}}</td>
                                        </tr>
                                    }
                                }
                            </table>
                        </div></tooltip-circle>
                    </div>

                    <dxi-column dataField="defaultHandlingMode" caption="Default {{tl.productHandlingMode}}" width="160px" headerCellTemplate="defaultHandlingModeHeaderTemplate" [allowEditing]="false"></dxi-column>

                    <div *dxTemplate="let cellInfo of 'defaultHandlingModeHeaderTemplate'">
                        Default {{tl.productHandlingMode}}
                        <tooltip-circle *ngIf="tl.defaultTooltip" tooltipId="defaulthandlingmodeheadertooltip{{cellInfo.rowIndex}}"><div class="basic-tooltip-text">
                            <div [innerHtml]="tl.defaultTooltip"></div>
                            <table class="tooltip-table">
                                @for(option of handlingModeOptions; track option) {
                                    @if(option.defaultTooltip) {
                                        <tr>
                                            <td><b>{{option.defaultDescription || option.description}}:</b></td><td class="pl-2">{{option.defaultTooltip}}</td>
                                        </tr>
                                    }
                                }
                            </table>
                        </div></tooltip-circle>
                    </div>

                    <dxi-column *ngIf="hasProductSettingCategories" dataField="category" [caption]="tl.productCategory" dataType="string" width="40%" [showEditorAlways]="true" editCellTemplate="categoryTemplate" headerCellTemplate="categoryHeaderTemplate"></dxi-column>

                    <div *dxTemplate="let cellInfo of 'categoryTemplate'" class="category-cell">
                        <dx-text-box *ngIf="!cellInfo.data.selectingCategory" [value]="cellInfo.value" (onValueChanged)="onCategoryValueChanged($event.value, cellInfo)"></dx-text-box>
                        <dx-lookup *ngIf="cellInfo.data.selectingCategory" [dataSource]="categories" [value]="cellInfo.value" [usePopover]="false" (onValueChanged)="onCategoryValueChanged($event.value, cellInfo)"
                        (onInitialized)="$event.component.open()" (onClosed)="cellInfo.data.selectingCategory = false">
                            <dxo-drop-down-options width="30vw" height="60vh"></dxo-drop-down-options>
                        </dx-lookup>
                        <i class="far fa-caret-square-down fa-lg" *ngIf="!cellInfo.data.selectingCategory" (click)="cellInfo.data.selectingCategory = true"></i>
                    </div>

                    <div *dxTemplate="let cellInfo of 'categoryHeaderTemplate'">
                        {{tl.productCategory}}
                        <tooltip-circle *ngIf="tl.productCategoryTooltip" tooltipId="categoryheadertooltip{{cellInfo.rowIndex}}"><div class="basic-tooltip-text" [innerHtml]="tl.productCategoryTooltip">
                        </div></tooltip-circle>
                    </div>
                </dx-data-grid>
                <div *ngIf="!context.productSettings" class="text-center loading-box m-3" data-cy="loading-spinner">
                    <h6>Fetching product settings...</h6>
                    <em class="far fa-4x fa-spin fa-spinner-third"></em>
                </div>
            </div>
            <div class="modal-footer">
                <button [disabled]="context.loading" class="btn btn-warning" (click)="ok()" style="margin-bottom:5px"><span *ngIf="context.loading"><span class="far fa-spin fa-cog"></span> Please wait...</span><span *ngIf="!context.loading">Ok</span></button>
                <button class="btn btn-default" (click)="cancel()" style="margin-bottom:5px">Cancel</button>
            </div>
        </div>
    </div>
</div>
